import React from 'react';
import { motion } from 'framer-motion';
import { Star, User } from 'lucide-react';
const reviews = [{
  name: 'อาจารย์สมชาย ท.',
  role: 'อาจารย์สอนฟุตบอล กรุงเทพฯ',
  quote: 'ในที่สุดก็มีอะไรที่ใช้งานได้จริง ฉันพบข้อบกพร่อง 3 จุดในการสอนของตัวเองตั้งแต่สัปดาห์แรก',
  color: 'bg-blue-500'
}, {
  name: 'อาจารย์วิไล ร.',
  role: 'โค้ชฟุตบอล เชียงใหม่',
  quote: 'ลดเวลาเตรียมงานได้ 80% ภายในเดือนแรก ไม่คิดว่าจะเป็นไปได้ด้วย PDF',
  color: 'bg-green-500'
}, {
  name: 'อาจารย์ประสิทธิ์ ม.',
  role: 'ผู้ฝึกสอน ขอนแก่น',
  quote: 'ในที่สุดก็หลุดพ้นจากการต้องคิดแผนใหม่ทุกวัน ระบบนี้ใช้งานได้จริง',
  color: 'bg-purple-500'
}];
export function TopReviews() {
  return <section className="w-full bg-navy-primary py-20 px-4" data-id="element-253">
      <div className="max-w-7xl mx-auto" data-id="element-254">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-display font-bold text-center text-white mb-12" data-id="element-255">
          อาจารย์กว่า 1,200 ท่านไว้วางใจ
        </motion.h2>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-256">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-white rounded-xl p-6 shadow-xl" data-id="element-257">
              <div className="flex items-start gap-4 mb-4" data-id="element-258">
                <div className={`w-12 h-12 rounded-full ${review.color} flex items-center justify-center flex-shrink-0`} data-id="element-259">
                  <User className="w-6 h-6 text-white" data-id="element-260" />
                </div>
                <div data-id="element-261">
                  <h3 className="font-bold text-navy-primary" data-id="element-262">{review.name}</h3>
                  <p className="text-sm text-gray-600" data-id="element-263">{review.role}</p>
                </div>
              </div>

              <div className="flex gap-1 mb-3" data-id="element-264">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-gold-accent text-gold-accent" data-id="element-265" />)}
              </div>

              <p className="text-gray-700 leading-relaxed" data-id="element-266">"{review.quote}"</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}